import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e976b4ee")

_pushScopeId("data-v-e976b4ee")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Menu")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Versione 3.3")
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "logo_ingegno" }, [
  /*#__PURE__*/_createVNode("img", { src: "assets/logo_ingegno.png" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_menu = _resolveComponent("ion-menu")

  return (_openBlock(), _createBlock(_component_ion_menu, {
    "menu-id": "app-menu",
    "content-id": "main-content"
  }, {
    default: _withId(() => [
      _createVNode(_component_ion_header, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_ion_list, { lines: "none" }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.config_menu, (item, i) => {
                return (_openBlock(), _createBlock("span", { key: i }, [
                  (item.show)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 0,
                        onClick: ($event: any) => ($setup.changePage(item.route)),
                        class: "menu_border_bottom"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_icon, {
                            icon: item.icon,
                            slot: "start"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu_title" }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createVNode(_component_ion_item, { onClick: $setup.openSimulator }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, {
                    icon: $setup.informationCircle,
                    slot: "start"
                  }, null, 8, ["icon"]),
                  _createVNode(_component_ion_label, { class: "menu_title" }, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})